import { useState, useEffect } from 'react';
import { sumBy } from 'lodash';
import { useFetch } from 'hooks';
import { Button, Filter, NoRecord, Table } from 'components/generic';
import { arrayBufferToBlob } from 'utils';

const CallbackRequest = () => {
	const [tableHeaders, setTableHeaders] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [tableDataCount, setTableDataCount] = useState(null);
	const [tableWidth, setTableWidth] = useState();
	const [tablePayload, setTablePayload] = useState({ start_index: 0, record_count: 20 });
	const [scrollbarEnable, setScrollbarEnable] = useState(false);
	const [scrollToTop, setScrollToTop] = useState(0);
	const api = useFetch();

	const gridStructure = async () => {
		const { data } = await api({ url: 'gridStructure/v1/CALLBACK_LATER', method: 'get' });
		setTableWidth(`${sumBy(data?.data[0]?.columns, 'columnWidth')}px`);
		setTableHeaders(data?.data[0]?.columns);
	};

	const tableDataAPI = async (payload, reset) => {
		const apiReq = { filter: payload?.filter, sort: payload?.sort || [{ id: '_id', value: -1 }], start_index: reset ? 0 : payload?.start_index, record_count: 20 };
		const { data } = await api({ url: 'dashboard/v1/CALLBACK_LATER', method: 'post', data: apiReq || {} });
		const elm = data?.data?.at();
		const tableData = elm?.results;
		if (tableData) {
			setTableData(prevState => (reset ? elm?.results : [...new Set([...prevState, ...tableData])]));
			setScrollbarEnable(elm?.results?.length);
			setTableDataCount(elm?.total);
		}
	};

	const setPayload = (payload, reset) => {
		setTablePayload(prevState => {
			console.log(tablePayload);
			const data = { ...prevState, ...payload, start_index: payload.incStartIndex ? prevState?.start_index + 20 : 0, record_count: 20 };
			tableDataAPI(data, reset);
			setScrollToTop(reset);
			return data;
		});
	};

	const handleFilter = e => {
		setPayload({ filter: e }, true);
	};

	const handleSort = e => {
		setPayload({ sort: [e] }, true);
	};

	const handleScroll = () => {
		setPayload({ incStartIndex: true }, false);
	};

	useEffect(() => {
		gridStructure();
		tableDataAPI({ start_index: 0, record_count: 20 });
	}, []);

	const handleDownload = async () => {
		const { data } = await api({ url: 'dashboard/v1/download/CALLBACK_LATER', method: 'post' });
		const buffer = data?.data?.data;
		arrayBufferToBlob(buffer, 'download', 'callbackLater.csv', 'csv');
	};

	return (
		<>
			<div className='transaction-table__container'>
				<div className='display-flex align-center flex-end'>
					<div style={{ marginRight: '10px' }}>
						<Button label='Download' height='35px' primary handleOnSubmit={handleDownload} />
					</div>
					<Filter filterObj={tableHeaders?.filter(el => el?.filterBy)} last handleSubmit={handleFilter} />
				</div>
				{tableDataCount && (
					<>
						<div className='transaction-table__display'>
							<Table tableHeader={tableHeaders} tableData={tableData} tableCount={tableDataCount} scrollToTop={scrollToTop} tableWidth={tableWidth} handleSort={handleSort} infiniteScroll={scrollbarEnable} handleScroll={handleScroll} />
						</div>
						<p className='transaction-table__count'>Total Records {tableDataCount}</p>
					</>
				)}

				{!tableDataCount && <NoRecord header='No callback requests found!' description='Please contact your Admin' height='90%' />}
			</div>
		</>
	);
};

export default CallbackRequest;
